import React from "react";
import SectionTitle from "../components/SectionTitle";
import ContactForm from "../components/ContactForm";
import { useLang } from "../context/LangContext";
import { ASSETS } from "../lib/content";

const STEPS_FR = [
  { k: "Brief", d: "Coordination 24/7 avec chef de bord & equipe propriétaire." },
  { k: "Arrivée", d: "Unité Exomobil sous 90 minutes en marina." },
  { k: "Soin", d: "Sessions individuelles, monitoring temps réel." },
  { k: "Reporting", d: "Synthèse récupération & suivi équipage." },
];
const STEPS_EN = [
  { k: "Brief", d: "24/7 coordination with captain & owner team." },
  { k: "Arrival", d: "Exomobil unit on marina within 90 minutes." },
  { k: "Care", d: "Individual sessions, real-time monitoring." },
  { k: "Reporting", d: "Recovery synthesis & crew follow-up." },
];

export default function YachtServices() {
  const { lang, t } = useLang();
  const steps = lang === "fr" ? STEPS_FR : STEPS_EN;
  return (
    <main className="pt-32" data-testid="page-yacht">
      <section className="container-luxe py-16">
        <SectionTitle eyebrow="YACHT SERVICES" title={t("home.yacht_title")} subtitle={t("home.yacht_sub")} />
      </section>
      <section className="container-luxe pb-16">
        <img src={ASSETS.yacht} alt="Monaco yacht" className="w-full h-[460px] object-cover rounded-md hairline" />
      </section>
      <section className="container-luxe pb-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-px hairline">
          {steps.map((s, i) => (
            <div key={s.k} className="bg-surface-1 p-8" data-testid={`yacht-step-${i}`}>
              <div className="overline">{`Step 0${i + 1}`}</div>
              <h3 className="font-display text-xl text-[var(--ink)] mt-3 font-light">{s.k}</h3>
              <p className="text-sm text-[var(--text-secondary)] mt-3">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="container-luxe pb-24">
        <ContactForm source="yacht" />
      </section>
    </main>
  );
}
